import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.register');
import { OnInit, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const FIELD_DEPARTMENTS = ['건축', '토목'];
const ALLOWED_DEPARTMENTS = [...FIELD_DEPARTMENTS, '운영본부', '기술본부'];

@Component({
    selector: 'wiz-component-auth-register',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.register/view.scss */
:host {
  display: block;
}

.register-form .input-field {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  border-radius: 0.65rem;
}
.register-form .department-option {
  min-height: 2.125rem;
  line-height: 1rem;
}

.field-department-panel {
  overflow: hidden;
  animation: fieldDepartmentIn 0.22s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes fieldDepartmentIn {
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    max-height: 48px;
    transform: translateY(0);
  }
}`],
})
export class ComponentAuthRegisterComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    public departmentGroups: string[] = ['현장본부', '운영본부', '기술본부'];
    public fieldDepartments: string[] = FIELD_DEPARTMENTS;

    public data: any = {
        id: '',
        password: '',
        password_confirm: '',
        name: '',
        email: '',
        departmentGroup: '',
        department: ''
    };

    public errors: any = {};

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.render();
    }

    public selectDepartmentGroup(group: string) {
        this.data.departmentGroup = group;
        if (group === '현장본부') {
            if (!FIELD_DEPARTMENTS.includes(this.data.department)) {
                this.data.department = '';
            }
        } else {
            this.data.department = group;
        }
        this.ref.detectChanges();
    }

    public selectFieldDepartment(department: string) {
        if (!FIELD_DEPARTMENTS.includes(department)) return;
        this.data.departmentGroup = '현장본부';
        this.data.department = department;
        this.ref.detectChanges();
    }

    public getDepartmentGroupClass(group: string): string {
        const base = 'department-option py-2 text-center rounded-xl border transition-all duration-200 text-xs font-semibold flex items-center justify-center';
        if (this.data.departmentGroup === group) {
            const activeMap: any = {
                '현장본부': 'bg-gradient-to-br from-blue-500 to-indigo-600 border-transparent text-white shadow-md shadow-blue-500/25',
                '운영본부': 'bg-gradient-to-br from-emerald-500 to-teal-600 border-transparent text-white shadow-md shadow-emerald-500/25',
                '기술본부': 'bg-gradient-to-br from-violet-500 to-purple-600 border-transparent text-white shadow-md shadow-violet-500/25'
            };
            return `${base} ${activeMap[group]}`;
        }

        const inactiveMap: any = {
            '현장본부': 'bg-white border-gray-200 text-slate-500 hover:border-blue-300 hover:text-blue-500',
            '운영본부': 'bg-white border-gray-200 text-slate-500 hover:border-emerald-300 hover:text-emerald-500',
            '기술본부': 'bg-white border-gray-200 text-slate-500 hover:border-violet-300 hover:text-violet-500'
        };
        return `${base} ${inactiveMap[group]}`;
    }

    public getFieldDepartmentClass(department: string): string {
        const base = 'department-option py-1.5 text-center rounded-lg border transition-all duration-200 text-xs font-semibold flex items-center justify-center';
        if (this.data.department === department) {
            return `${base} ${department === '건축'
                ? 'bg-blue-600 border-blue-600 text-white shadow-sm'
                : 'bg-orange-500 border-orange-500 text-white shadow-sm'}`;
        }
        return `${base} bg-white border-gray-200 text-slate-500 hover:border-slate-300 hover:text-slate-700`;
    }

    public async register() {
        if (!this.validate()) {
            const firstError = Object.values(this.errors)[0] as string;
            await this.service.alert.show({ message: firstError, status: 'error', action: '확인' });
            return;
        }

        const user = { ...this.data };
        delete user.password_confirm;
        delete user.departmentGroup;
        user.password = this.service.auth.hash(user.password);

        const { code, data } = await wiz.call('register', user);
        if (code === 200) {
            await this.service.alert.show({
                title: '가입 성공',
                message: '성공적으로 가입되었습니다. 로그인 페이지로 이동합니다.',
                status: 'success',
                action: '확인'
            });
            this.gotoLogin();
            return;
        }

        await this.service.alert.show({ message: data, status: 'error', action: '확인' });
    }

    public validate(): boolean {
        this.errors = {};
        if (!ALLOWED_DEPARTMENTS.includes(this.data.department)) this.errors.department = '소속을 선택해주세요.';
        if (!this.data.id?.trim()) this.errors.id = '아이디를 입력해주세요.';
        if (!this.data.name?.trim()) this.errors.name = '이름을 입력해주세요.';
        if (!this.data.email?.trim()) this.errors.email = '이메일을 입력해주세요.';
        if (!this.data.password) this.errors.password = '비밀번호를 입력해주세요.';
        if (this.data.password !== this.data.password_confirm) this.errors.password_confirm = '비밀번호가 일치하지 않습니다.';
        return Object.keys(this.errors).length === 0;
    }

    public gotoLogin() {
        this.changeMode.emit('login');
    }
}

export default ComponentAuthRegisterComponent;